import React from 'react';
import { classNames } from '@/shared/lib/classnames/classnames';
interface Props {
  sectionId?: string;
  className?: string;
  title: string;
  children: React.ReactNode;
}
export const DoctorListInCard: React.FC<Props> = ({
  sectionId,
  className,
  title,
  children
}) => {
  return <section id={sectionId} className={classNames('', {}, [className])} data-sentry-component="DoctorListInCard" data-sentry-source-file="index.tsx">
      <h2 className="text-center">{title}</h2>
      {children}
    </section>;
};